import React, { useEffect, useState } from 'react';
import { Button, Col, ComponentLoader, ContentContainer, Row, TextLink } from '@snsw/react-component-library';
import { IconNotificationError } from '@snsw/react-component-library/build/Icons/system';
import styles from '../Page.module.scss';
import { PagePath } from 'shared/constants/pagePath';
import { useDispatch, useSelector } from 'react-redux';
import { UserPasswordlessManager } from 'shared/oidc/passwordLessUserManager';
import { clearPlantDesignForm, storeRedirect } from 'plantItemNew/redux/slices/formSlice';
import { Link } from 'react-router-dom';
import { PlantItemConstants } from 'plantItemNew/constants/plantItemConstants';

export const UnauthorizedApplicationError = (props) => {
  const application = useSelector((state) => state.application);
  const dispatch = useDispatch();
  const [landingPagePath, setLandingPagePath] = useState('');
  const [resumeApplicationPath, setResumeApplicationApplicationPath] = useState('');

  const [isLoading, setIsLoading] = useState(false);

  const isPlantItemApplication = props.licenceType === PlantItemConstants.licenceType;

  useEffect(() => {
    if (!props.licenceType) return;

    if (props.licenceType === PlantItemConstants.licenceType) {
      setLandingPagePath(PagePath.landing);
      setResumeApplicationApplicationPath(PagePath.applicationById);
    } else {
      setLandingPagePath(PagePath.plantDesignBeforeYouStart);
      setResumeApplicationApplicationPath(PagePath.plantDesignApplicationById);
    }
  }, [props.licenceType]);

  const reLogin = () => {
    const redirectUrl = resumeApplicationPath.replace(':id', application.applicationId);

    setIsLoading(true);

    UserPasswordlessManager.instance().stopSilentRenew();

    dispatch(clearPlantDesignForm());
    dispatch(storeRedirect(redirectUrl));
    UserPasswordlessManager.instance().signoutRedirect();
  };

  return (
    <>
      <ContentContainer>
        <Row className={styles.errorHeader}>
          <Col span={8}>
            <IconNotificationError />
            <span>The email address you entered does not match this application.</span>
          </Col>
        </Row>
        <Row>
          <Col span={8}>
            <div className={styles.errorSuggestion}>
              You can:
              <ul>
                <li>enter your email address again - it must be the one you used to start this application, or</li>
                <li>
                  begin{' '}
                  <TextLink as={Link} href={landingPagePath}>
                    a new application
                  </TextLink>{' '}
                  for this {isPlantItemApplication ? 'plant items' : 'plant design'}.
                </li>
              </ul>
            </div>
            <Button className={styles.marginTopTwoHalfRem} onClick={reLogin}>
              Enter email address
            </Button>
          </Col>
        </Row>

        {isLoading && (
          <Row>
            <Col span={12}>
              <ComponentLoader fullPage />
            </Col>
          </Row>
        )}
      </ContentContainer>
    </>
  );
};
